// remodal iosのみ背景固定処理
if (navigator.userAgent.match(/(iPhone|iPod|)/)) {
  $(document).on('opening', '.remodal', function () {
    TOP = document.documentElement.scrollTop || document.body.scrollTop;
    TOP *= -1;
    document.querySelector('body').style.position = 'fixed';
    document.querySelector('body').style.width = '100%';
    document.querySelector('body').style.top = TOP + 'px';
  });
  $(document).on('closing', '.remodal', function () {
    _top = Math.abs(TOP);
    document.querySelector('body').removeAttribute('style');
    window.scrollTo(0, _top);
  });
}
